import React from 'react'

const PersonalisedTab = () => {

    return (
        <div className='absolute right-0 top-2 flex rounded-lg bg-gradient-to-r from-[#244968] to-[#54A3F5] py-1'>
            <img src="https://img.learntube.ai/public-assets/premium_1.svg?updatedAt=1689229408174" width={16} height={16} alt="" className='ml-2' />
            <p className='text-[11px] mx-2'>Personalised For You</p>
        </div>
    )
}

export default PersonalisedTab
